import { Button } from "@/components/Button"
import { Edit } from "@/Images"
import { PaymentSystem, useNewPayment } from "@usher/pe-client-front-end-lib"
import { useCallback, useState } from "react"
import { FormProvider } from "react-hook-form"
import { useHistory } from "react-router-dom"
import { ConfirmModal } from "./ConfirmModal"
import { TransferDetails } from "./Details"
import { TransferForm } from "./Form"
import "./style.sass"

interface Props {
  currentStep: number
  onNext: (step: number) => void
  paymentSystem: PaymentSystem
  currency: string
}
export const Transfer = ({ currency, currentStep, onNext, paymentSystem }: Props) => {
  const history = useHistory()
  const { iban, setIban, formModel, sendOTP, createPayment, loading } = useNewPayment(
    () => {
      setShowModal(true)
    },
    () => history.push("/iban/payments"),
  )
  const state = formModel.getValues()
  const [showModal, setShowModal] = useState(false)
  const trigger = formModel.trigger
  const getValues = formModel.getValues
  const isLast = currentStep === 2
  const gotoDetails = useCallback(async () => {
    const values = getValues()
    sendOTP({ amount: values.amount })
  }, [sendOTP, getValues])

  return (
    <div className="transfer mt-6">
      <FormProvider {...formModel}>
        {currentStep === 1 ? <TransferForm onIbanSelect={setIban} iban={iban} /> : <TransferDetails />}
        <div className="flex flex-col items-center mt-2.5 bg-white p-[20px] justify-end gap-[10px] child:w-full sm:child:w-auto sm:flex-row border">
          {isLast ? (
            <Button color="inherit" onClick={() => onNext(currentStep - 1)}>
              <Edit /> Modify
            </Button>
          ) : (
            <Button to="/iban/payments" color="inherit">
              Cancel Order
            </Button>
          )}
          <Button
            loading={!showModal && loading}
            onClick={
              isLast
                ? gotoDetails
                : async () => {
                    const result = await trigger()
                    if (result) {
                      onNext(currentStep + 1)
                    }
                  }
            }
          >
            {isLast ? "Confirm with code" : "Next"}
          </Button>
        </div>
        <ConfirmModal
          loading={loading}
          onSend={createPayment}
          show={showModal}
          onClose={() => {
            setShowModal(false)
          }}
          data={{ total: state.amount, currency, payWith: paymentSystem }}
        />
      </FormProvider>
    </div>
  )
}
